<template>
  <div class="nav bc">
    <div flex="cross:center main:center">
      <div flex-box="0" class="logo csp">
        <router-link to="/">
          <img src="/imgs/logo.png" width="88" alt="" />
        </router-link>
      </div>
      <el-menu :default-active="activeIndex" active-text-color="#409eff" mode="horizontal" @select="handleSelect">
        <el-menu-item index="advantage"><router-link class="db" to="/advantage">平台优势</router-link></el-menu-item>
        <el-menu-item index="introduction">
          <router-link class="db" to="/introduction">产品介绍</router-link>
        </el-menu-item>
        <el-menu-item index="localization">
          <router-link class="db" to="/marketing">品牌营销</router-link>
        </el-menu-item>
        <el-menu-item index="caseinsight">
          <router-link class="db" to="/caseinsight">案例洞察</router-link>
        </el-menu-item>
        <el-menu-item index="advertising">
          <router-link class="db" to="/advertising">广告投放</router-link>
        </el-menu-item>
        <el-submenu index="more">
          <template slot="title">了解更多</template>
          <el-menu-item index="contact"><router-link class="db" to="/contact">联系我们</router-link></el-menu-item>
          <!-- <el-menu-item index="news"><router-link class="db" to="/news">新闻动态</router-link></el-menu-item>
          <el-menu-item index="agent"><router-link class="db" to="/agent">代理商查询</router-link></el-menu-item> -->
        </el-submenu>
      </el-menu>
      <!-- <el-tag effect="dark" class="csp m-l-8" @click="showContactForm = true">免费咨询</el-tag> -->
    </div>
    <ContactForm :show="showContactForm" @hide="showContactForm = false" />
  </div>
</template>

<script>
import ContactForm from './ContactFormDialog';
export default {
  props: {},
  data() {
    return {
      showContactForm: false,
    };
  },
  components: { ContactForm },
  computed: {
    activeIndex() {
      return this.$route.name;
    },
  },
  methods: {
    handleSelect() {},
  },
};
</script>

<style scoped lang="scss">
.nav {
  max-width: 1200px;
  .el-menu {
    border: 0 none;
    > .el-menu-item {
      padding: 0;
      border: 0 none !important;
      a {
        padding: 0 10px;
      }
    }
  }
}
.logo {
  margin: 0 80px 0 0;
}
</style>
